import { render, staticRenderFns } from "./AddPhy.vue?vue&type=template&id=70e56157&"
import script from "./AddPhy.vue?vue&type=script&lang=js&"
export * from "./AddPhy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports